module.exports = __webpack_public_path__ + "img/main.716a9702.png";